import { render, staticRenderFns } from "./twelve.vue?vue&type=template&id=bdb342d6"
import script from "./twelve.vue?vue&type=script&lang=js"
export * from "./twelve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports